<template>
  <vx-card>
    <div class="vs-con-loading__container" v-if="carregadoFull == false"></div>
    <div class="mt-5" v-if="dadosProposta != {}">
      <h3 class="flex gap-2 mb-6">
        {{ $t('Proposta') }}
        {{
          `${dadosProposta.idProposta} ${
            verificaEmpresaBemProtege(dadosProposta.idEmpresa) ? '-' : ''
          }`
        }}
        <div v-if="verificaEmpresaBemProtege(dadosProposta.idEmpresa)">
          <vs-chip
            :color="getStatusColor(dadosProposta.idStatus)"
            class="product-order-status"
          >
            {{ dadosProposta.nomeStatus }}
          </vs-chip>
        </div>
      </h3>
      <div
        v-if="!(resposavelVistoria || !statusAguardandoAprovacao)"
        class="vx-row mb-3"
      >
        <div class="vx-col w-full">
          <vs-alert style="height: auto" active="true" color="warning">
            {{
              `${$t('Esta')} ${$t('proposta')} ${$t('está')} ${$t(
                'bloqueada',
              )} ${$t('para')} ${$t('alterações')} ${$t('pois')} ${$t(
                'está',
              )} ${$t('no')} ${$t('status')} "${$t(
                'Aguardando Aprovação',
              )}", ${$t('somente')} ${$t('o')} ${$t('responsável')} ${$t(
                'pela',
              )} ${$t('análise')} ${$t('pode')} ${$t('fazer')} ${$t(
                'alterações.',
              )}`
            }}
          </vs-alert>
        </div>
      </div>

      <div class="text-right" v-if="carregadoFull == true">
        <vs-button
          v-if="
            dadosProposta.idStatus != 4 &&
            dadosProposta.idStatus != 2 &&
            (resposavelVistoria ||
              !statusAguardandoAprovacao ||
              $can('Salvar proposta Independentemente de Status', 'Vistorias'))
          "
          color="success"
          type="gradient"
          class="mr-3 mb-2 w-full sm:w-auto"
          @click="openModalProdutos()"
          >{{
            `${$t('Buscar')} ${$t('e')} ${$t('Atualizar')} ${$t('Produtos')}`
          }}</vs-button
        >
        <vs-button
          v-if="dadosProposta.idStatus == 4"
          color="success"
          type="gradient"
          class="mr-3 mb-2 w-full sm:w-auto"
          @click="openModalProdutos()"
          :configurarComissao="configurarComissao"
        >
          {{ `${$t('Visualizar')} ${$t('Produtos')}` }}
        </vs-button>

        <vs-button
          :to="`/detalheVistoria/${dadosProposta.idProposta}`"
          color="dark"
          type="gradient"
          class="mr-3 mb-2 w-full sm:w-auto"
        >
          <vs-icon icon="camera" class="mr-3"></vs-icon>
          {{ `${$t('Detalhes')} ${$t('da')} ${$t('Proposta')}` }}
        </vs-button>

        <vs-button
          target="_blank"
          :to="
            dadosProposta.idFrota && dadosProposta.chaveMultiProposta
              ? `/multi-propostas/${dadosProposta.chaveMultiProposta}`
              : `/proposta/${dadosProposta.chave}?interno=true`
          "
          color="warning"
          type="gradient"
          class="mr-3 mb-2 w-full sm:w-auto"
        >
          <vs-icon icon="send" class="mr-3"></vs-icon>
          {{ `${$t('Visualizar')} ${$t('Proposta')}` }}</vs-button
        >

        <vs-button
          v-if="$can('Exibir Historico Alteracoes', 'Cotações')"
          color="primary"
          type="gradient"
          class="mr-3 w-full sm:w-auto"
          @click="openModalLogs(dadosProposta)"
        >
          <vs-icon icon="list" class="mr-3"></vs-icon
          >{{ `${$t('Histórico')}` }}</vs-button
        >
        <vs-button
          v-if="
            $can('Editar proposta finalizada', 'Cotações') &&
            dadosProposta.idStatus == 4
          "
          color="danger"
          type="gradient"
          class="mr-3 w-full sm:w-auto"
          @click="voltarStatusProposta(true)"
        >
          <vs-icon icon="list" class="mr-3"></vs-icon
          >{{
            `${$t('Voltar')} ${$t('status')} ${$t('da')} ${$t('Proposta')}`
          }}</vs-button
        >
      </div>
      <form role="form" @submit.stop.prevent="onSubmit">
        <h3 class="mb-3 mt-6">{{ $t('Dados') }} {{ $t('Gerais') }}</h3>
        <hr class="mb-6" />
        <formDadosGerais
          v-if="dadosEmpresaLoaded == true"
          :formulario.sync="form"
          :dadosProposta="dadosProposta"
          :regionais="regionais"
          :divisoes="divisoes"
          :colaboradoresCadastro="colaboradoresCadastro"
          :status="status"
          :consultores="consultores"
          :fotos="fotos"
          :dadosUsuario="dadosUsuario"
          :dadosEmpresa="dadosEmpresa"
          @loaded.once="carregaFormPai"
          @changed="alteraFormPai"
          @changeProposalType="changeProposalType"
        ></formDadosGerais>
        <h3 class="mb-3 mt-6">
          {{ $t('Dados') }} {{ $t('do') }} {{ $t('Cliente') }}
        </h3>
        <hr class="mb-6" />
        <formDadosCliente
          :formulario="form"
          :dadosProposta="dadosProposta"
          :regionais="regionais"
          @loaded.once="carregaFormPai"
          @changed="alteraFormPai"
        ></formDadosCliente>
        <h3 class="mb-3 mt-6">
          {{ $t('Dados') }} {{ $t('do') }} {{ $t('Veículo') }}
        </h3>
        <hr class="mb-6" />
        <formDadosVeiculo
          v-if="dadosEmpresaLoaded == true"
          ref="changePorposalTypeMethod"
          :formulario="form"
          :dadosProposta="dadosProposta"
          :grupos="grupos"
          :combustiveis="listaCombustiveis"
          :cores="listaCores"
          :cidadeCliente="cidadeAux"
          :estadoCliente="estadoAux"
          :idUsuario="idUsuario"
          :permitePlacaRepetida="permiteVariasCotacoesPorPlaca"
          :carregadoFull="carregadoFull"
          :idRegional="form.dadosGerais.idRegional"
          :dadosEmpresa="dadosEmpresa"
          :verificaStatusAlterarPlacaChassi="verificaStatusAlterarPlacaChassi"
          @loaded.once="carregaFormPai"
          @changed="alteraFormPai"
          @salvar="onSubmit()"
          @permitSalvar="validaSituacaoPlacaChassi"
        ></formDadosVeiculo>
        <vs-popup
          id="meu-popup-personalizado"
          class="holamundo"
          :title="`${$t('Produtos')} ${$t('a')} ${$t('Serem')} ${$t(
            'Atualizados',
          )}`"
          :active.sync="modalProdutos"
          @close="(modalProdutos = false), (precisaAlterarProduto = false)"
        >
          <formDadosProduto
            :formulario="form"
            :dadosProposta="dadosProposta"
            :precisaAlterarProduto="precisaAlterarProduto"
            @loaded="carregaFormPai"
            @changed="alteraFormPai"
            @salvar="
              modalProdutos = false;
              precisaAlterarProduto = false;
              buscarAtualizarProds = true;
              onSubmit();
            "
            @naoSalvarProdutos="naoSalvarProdutos"
            @atualizarParticipacao="atualizarParticipacao"
            :regional="regional"
            :configurarComissao="configurarComissao"
            :dadosEmpresa="dadosEmpresa"
          ></formDadosProduto>
        </vs-popup>

        <vs-popup
          fullscreen
          class="holamundo"
          :title="`${$t('Histórico')} ${$t('de')} ${$t('Alterações')}`"
          :active.sync="modalLogs"
          @close="resetModalLogs()"
        >
          <h3 class="mb-6">
            {{ $t('Proposta') }} {{ this.dadosProposta.idProposta }}
          </h3>
          <vs-table
            class="tablePrincipal"
            noDataText="Sem Alterações"
            ref="table"
            stripe
            search
            :data="logsAlteracoes"
          >
            <template slot="thead">
              <vs-th sort-key="tabela" class="uppercase">Referência</vs-th>
              <vs-th sort-key="campo" class="uppercase">Campo</vs-th>
              <vs-th sort-key="dadoOld" class="uppercase">Dado anterior</vs-th>
              <vs-th sort-key="dadoNew" class="uppercase">Dado posterior</vs-th>
              <vs-th sort-key="user" class="uppercase"
                >{{ $t('Usuário') }} {{ $t('da') }} {{ $t('alteração') }}</vs-th
              >
              <vs-th sort-key="createdAt" class="uppercase"
                >{{ $t('Data') }} {{ $t('e') }} {{ $t('Hora') }} {{ $t('da') }}
                {{ $t('Alteração') }}</vs-th
              >
            </template>
            <template slot-scope="{ data }">
              <tbody>
                <vs-tr v-for="(item, index) in data" :key="index">
                  <vs-td class="product-tabela">
                    <p>{{ item.tabela }}</p>
                  </vs-td>
                  <vs-td class="product-campo">
                    <p
                      v-if="
                        [
                          'PropostasProdutosComplementos',
                          'propostasProdutos',
                        ].includes(item.tabela) &&
                        item.campo != 'produtoAdicionado' &&
                        item.campo != 'produtoDeletado'
                      "
                    >
                      {{ item.nomeProduto }}
                    </p>
                    <p class="font-bold">{{ item.campo }}</p>
                  </vs-td>

                  <vs-td class="product-dadoOld">
                    <div class="flex">
                      {{ item.dadoOld ? item.dadoOld : '-' }}
                      <p
                        v-if="
                          [
                            'PropostasProdutosComplementos',
                            'propostasProdutos',
                          ].includes(item.tabela) &&
                          item.campo == 'produtoDeletado'
                        "
                      >
                        -
                        {{ item.nomeProduto }}
                      </p>
                    </div>
                  </vs-td>

                  <vs-td class="product-dadoNew">
                    <div class="flex">
                      {{ item.dadoNew ? item.dadoNew : '-' }}
                      <p
                        v-if="
                          [
                            'PropostasProdutosComplementos',
                            'propostasProdutos',
                          ].includes(item.tabela) &&
                          item.campo == 'produtoAdicionado'
                        "
                      >
                        -
                        {{ item.nomeProduto }}
                      </p>
                    </div>
                  </vs-td>

                  <vs-td class="product-user"
                    >{{ item.user }} - {{ item.nomeUsuario }}
                  </vs-td>

                  <vs-td class="product-createdAt pl-6">{{
                    item.createdAt
                  }}</vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vs-popup>
        <h3 class="mb-3 mt-6">{{ $t('Dados') }} {{ $t('Financeiros') }}</h3>
        <hr class="mb-6" />
        <formDadosFinanceiro
          :dadosProposta="dadosProposta"
          :produtosSelecionados="form.dadosProduto.produtosSelecionados"
          :key="shouldRenderChild"
          :dadosEmpresa="dadosEmpresa"
          @loaded.once="carregaFormPai"
          @changed="alteraFormPai"
          @alteraVencimento="alteraVencimento"
        ></formDadosFinanceiro>

        <div
          v-if="!(resposavelVistoria || !statusAguardandoAprovacao)"
          class="vx-row mt-3"
        >
          <div class="vx-col w-full">
            <vs-alert style="height: auto" active="true" color="warning">
              {{ $t('Esta') }} {{ $t('proposta') }} {{ $t('esta') }}
              {{ $t('bloqueada') }} {{ $t('para') }} {{ $t('alterações') }}
              {{ $t('pois') }} {{ $t('esta') }} {{ $t('no') }}
              {{ $t('status') }} "Aguardando Aprovação", {{ $t('somente') }}
              {{ $t('o') }} {{ $t('responsável') }} {{ $t('pela') }}
              {{ $t('vistoria') }} {{ $t('pode') }} {{ $t('fazer') }}
              {{ $t('alterações.') }}
            </vs-alert>
          </div>
        </div>
        <div class="vx-row mt-3" v-if="carregadoFull == true">
          <div
            v-if="precisaAlterarProduto == false"
            class="vx-col w-full text-right"
          >
            <vs-button
              class="mr-5"
              v-if="
                (this.dadosProposta.idStatus == 7 ||
                  this.dadosProposta.idStatus == 5) &&
                $can('Aceitar Pré Análise', 'Vistorias')
              "
              @click.stop.prevent="liberarAguardandoAprovacao"
              >{{ $t('Liberar') }} {{ $t('para') }} " {{ $t('Aguardando') }}
              {{ $t('Aprovação') }}"</vs-button
            >
            <BotaoSubmit
              v-if="
                validaLiberacaoBotaoSalvar(
                  semRetricao,
                  dadosProposta.idStatus,
                  resposavelVistoria,
                  statusAguardandoAprovacao,
                  $can(
                    'Salvar proposta Independentemente de Status',
                    'Vistorias',
                  ),
                )
              "
              variant="success"
              :edit="true"
              :aguarde="aguardeCadastro"
              :disabled="habilitaDesabilitaBtnSalvar"
            ></BotaoSubmit>
          </div>
        </div>
      </form>
    </div>
  </vx-card>
</template>

<script>
import jwt from 'jsonwebtoken';
import service from './../../services';
import locale from './../../locale';
import BotaoSubmit from '../../components/BotaoSubmit';
import formDadosGerais from './../forms/formProposta_p0';
import formDadosCliente from './../forms/formProposta_p1';
import formDadosVeiculo from './../forms/formProposta_p2';
import formDadosProduto from './../forms/formProposta_p3';
import moment from 'moment';
import formDadosFinanceiro from './../forms/formProposta_p4';
import cpfCnpj from '../../services/cpfCnpj';
import {
  obterDadosUsuarioLogado,
  verificaUsuarioAdmin,
} from './../../services/usuario';
import functions from '../../utils/functions';
import { STATUS_COTACAO } from '../../commons/status-cotacao';
import { decryptData } from './../../services/decryptData';
import {
  getFromCache,
  saveToCache,
  isValidCachedData,
} from '../../services/cacheService';
import { getTranslate } from '@/services/translate/translate';
import { SITUACAO_PLACA } from '../../commons/constant/codigo-situacao-placa';

export default {
  components: {
    BotaoSubmit,
    formDadosGerais,
    formDadosCliente,
    formDadosVeiculo,
    formDadosProduto,
    formDadosFinanceiro,
  },
  watch: {
    precisaAlterarProduto: function (newValue) {
      if (newValue) {
        this.notificar(
          'Os dados da proposta foram alterados, revise os produtos',
          'warning',
        );
      }
    },
    aceiteUnificacao() {
      if (this.aceiteUnificacao) {
        this.onSubmit();
      }
    },
  },
  computed: {
    semRetricao() {
      return this.$can('Edição sem Restrição', 'Cotações');
    },
    resposavelVistoria() {
      const { idResponsavel } = this.dadosProposta;
      return idResponsavel === this.idUsuario;
    },
    statusAguardandoAprovacao() {
      const { nomeStatus, idStatus } = this.dadosProposta;
      return nomeStatus === 'Aguardando Aprovação' && idStatus === 3;
    },
    propostaFinalizada() {
      const { idStatus, nomeStatus } = this.dadosProposta;
      return idStatus === 4 && nomeStatus === 'Finalizada';
    },
  },
  data() {
    return {
      dadosUsuario: null,
      msg: null,
      ativaMascarasVeiculos: false,
      mensal: 0,
      shouldRenderChild: 0,
      buscarAtualizarProds: false,
      cidadeAux: null,
      estadoAux: null,
      idEmpresa: null,
      idUsuario: null,
      textoMsgNotificacao: null,
      corMessagemNoticacao: 'success',
      openCollapseDadosGerais: true,
      openCollapseDadosCliente: true,
      openCollapseDadosVeiculo: true,
      modalProdutos: false,
      aguardeCadastro: false,
      dadosProposta: {},
      precisaAlterarProduto: false,
      regionais: [],
      divisoes: [],
      consultores: [],
      colaboradoresCadastro: [],
      status: [],
      grupos: [],
      listaCores: [],
      listaCombustiveis: [],
      fotos: [],
      form: {
        dadosGerais: {},
        dadosCliente: {},
        dadosVeiculo: {},
        dadosProduto: {},
      },
      passo: 0,
      carregadoFull: false,
      modalLogs: false,
      logsAlteracoes: [],
      aceiteUnificacao: null,
      formUnificacao: {},
      permiteVariasCotacoesPorPlaca: false,
      codigoSituacaoPlaca: 0,
      habilitaDesabilitaBtnSalvar: false,
      camposValidacaoObrigatorios: [
        'Regional',
        'Tipo de Proposta',
        'Origem',
        'Consultor',
        'Divisão',
        'Chassi',
        'Estado',
        'Cidade',
      ],
      formEdicaoInvalido: false,
      regional: {},
      configurarComissao: false,
      dadosEmpresa: {},
      dadosEmpresaLoaded: false,
      verificaStatusAlterarPlacaChassi: false,
    };
  },
  methods: {
    async translate(companyId) {
      const translate = await getTranslate(companyId);

      if (translate) {
        const nameDefaultLocale = `defaultLabels`;
        this.$i18n.mergeLocaleMessage(nameDefaultLocale, translate);
        this.$i18n.locale = nameDefaultLocale;
      }
    },
    validaLiberacaoBotaoSalvar(
      semRetricao,
      idStatus,
      resposavelVistoria,
      statusAguardandoAprovacao,
      permissao,
    ) {
      let liberado = false;
      if (permissao == true) {
        liberado = true;
      } else {
        if (idStatus == 2 || idStatus == 4) {
          liberado = false;
        } else {
          if (resposavelVistoria || !statusAguardandoAprovacao) liberado = true;
          if (semRetricao) liberado = true;
        }
      }
      return liberado;
    },
    forceRenderChild() {
      this.shouldRenderChild++;
    },
    notificar(text, corNotificacao, tempoExibirNotificacao) {
      const mensagem =
        text || `Os dados da proposta foram alterados, revise os produtos`;
      const color = corNotificacao || 'danger';
      const time = tempoExibirNotificacao || 4000;

      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: mensagem,
        color,
        time,
      });

      this.textoMsgNotificacao = null;
      this.corMessagemNoticacao = null;
    },
    async onSubmit() {
      const [...errosValidacao] = this.$validator.errors.items;
      this.preencheProdutosSelecionadosFinanceiroOnSubmit();

      const temalorVeiculoZero =
        Boolean(this.form.dadosVeiculo.veiculo.valorCobertura) &&
        Boolean(this.form.dadosVeiculo.veiculo.valorFipe);

      if (!temalorVeiculoZero) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Preço FIPE ou Valor de cobertura zerado',
          color: 'danger',
          time: 5000,
        });
      } else {
        this.form.dadosProposta = this.dadosProposta;

        this.validarCamposFormulario(errosValidacao);

        if (this.formEdicaoInvalido) {
          this.formEdicaoInvalido = false;
          return;
        }

        const validaDataSaidaNfVeiculoZero =
          this.form.dadosVeiculo.isZero && !this.form.dadosVeiculo.dataNf;

        if (validaDataSaidaNfVeiculoZero) {
          this.notificar(
            'Informe a data de saída da nota físcal',
            'danger',
            5000,
          );
          return;
        }

        if (
          this.form.dadosVeiculo.placa ===
            this.form.dadosVeiculo.placaSubstituicao &&
          this.form.tipoProposta == 'Substituição'
        ) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Placas de entrada e saída não podem ser iguais',
            color: 'danger',
          });
          return;
        }
        this.ajustaKm();

        if (this.form.dadosCliente.cpfcnpj) {
          if (
            cpfCnpj.valida_cpf_cnpj(this.form.dadosCliente.cpfcnpj) == false
          ) {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Este CPF ou CNPJ não é válido`,
              color: 'danger',
            });
            return;
          }
        }

        if (this.form.dadosGerais.tipoProposta === 'Contratação') {
          this.form.dadosGerais.tipoProposta = 'Adesão';
        }

        this.aguardeCadastro = true;
        this.$vs.loading();

        const atualizaPropostaGeral = service.post(
          'Cotacao',
          'AtualizarPropostaGeral',
          this.form,
        );

        const atualizaTabelaProposta = this.dadosProposta
          .diaVencimentoMensalidade
          ? await service.post('Grupo', 'atualiza-tabela-proposta', {
              idProposta: this.form.dadosProposta.idProposta,
              diaVencimentoMensalidade:
                this.dadosProposta.diaVencimentoMensalidade,
            })
          : Promise.resolve(); // Se não houver diaVencimentoMensalidade, resolve a Promise imediatamente

        Promise.all([atualizaPropostaGeral, atualizaTabelaProposta])
          .then(() => {
            this.aguardeCadastro = false;
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Operação Realizada com sucesso`,
              color: 'success',
            });

            this.$emit('concluido');

            this.$vs.loading.close();
            this.aguardeCadastro = false;

            setTimeout(() => this.recarregaPagina(), 2000);
          })
          .catch((error) => {
            this.aguardeCadastro = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: error,
              color: 'danger',
            });

            setTimeout(() => this.recarregaPagina(), 3000);
          });
      }

      this.buscarAtualizarProds = false;
    },
    recarregaFormFinanceiro() {
      this.$emit('recarregaFinanceiro');
    },
    carregaFormPai({ formulario, ...data }) {
      this.form[formulario] = data;
    },
    alteraFormPai({ formulario, id, value }) {
      if (this.form.dadosCliente.unificaAssociado) {
        this.aceiteUnificacao = this.form.dadosCliente.unificaAssociado;
      }
      this.form[formulario][id] = value;
      if (id === 'tipoProposta') {
        this.dadosProposta.tipoProposta = this.form.dadosGerais.tipoProposta;
      }
      if (id === 'edicaoVeiculoliberada') {
        this.habilitaDesabilitaBtnSalvar = value;
      }
      this.validaAlteracaoProduto({ id, value });
    },
    alteraVencimento(diaVencimento) {
      this.dadosProposta.diaVencimentoMensalidade = diaVencimento;
    },
    validaAlteracaoProduto(obj) {
      const { id, value } = obj;
      let _precisaAlterarProduto = false;

      const formFiltroStorage = localStorage.getItem('formFiltro');
      const formFiltro =
        formFiltroStorage !== null ? JSON.parse(formFiltroStorage) : {};
      const formFiltroVazio = this._isObjectEmpty(formFiltro);

      const { tipoProposta, restricoes, valorNf } = this.dadosProposta;

      const { cidade, estado } = this.dadosProposta.dadosCliente;

      const { cilindradas, valorCobertura } = this.dadosProposta.dadosVeiculo;

      const {
        tipoProposta: tipoPropostaFormFiltro,
        cidade: cidadeFormFiltro,
        estado: estadoFormFiltro,
      } = formFiltro;

      let existeDiferecaRestricoes = null;
      let temResultFipeVazio = null;
      let preco = null;

      switch (id) {
        case 'restricoesSelecionadas':
          const arrIdsRestricoesProposta = restricoes.reduce(
            (acc, { idRestricao }) => {
              acc.push(idRestricao);
              return acc;
            },
            [],
          );

          existeDiferecaRestricoes =
            JSON.stringify(value) !== JSON.stringify(arrIdsRestricoesProposta);

          _precisaAlterarProduto = existeDiferecaRestricoes
            ? true
            : _precisaAlterarProduto;

          if (_precisaAlterarProduto)
            this.openModalProdutos(_precisaAlterarProduto);
          break;
        case 'valorNf': //com bug não permite fechar o modal de produtos
          if (valorNf == null && value == '0,00')
            return (_precisaAlterarProduto = false);

          const isStringformValorNf = typeof value === 'string' && value;

          if (isStringformValorNf) {
            const valorNfFormatado = parseFloat(
              value.replace('.', '').replace(',', '.'),
            );
            const exiteDiferencaValorNf = valorNfFormatado !== valorNf;

            _precisaAlterarProduto = exiteDiferencaValorNf
              ? true
              : _precisaAlterarProduto;
          }

          if (_precisaAlterarProduto)
            this.openModalProdutos(_precisaAlterarProduto);
          break;
        case 'cidade':
          _precisaAlterarProduto =
            value !== cidade ? true : _precisaAlterarProduto;

          if (!formFiltroVazio)
            _precisaAlterarProduto =
              value !== cidadeFormFiltro ? true : _precisaAlterarProduto;

          this.cidadeAux = value;
          if (!this.cidadeAux) _precisaAlterarProduto = false;
          if (_precisaAlterarProduto)
            this.openModalProdutos(_precisaAlterarProduto);
          break;
        /*case 'estado':
          _precisaAlterarProduto =
            value !== estado ? true : _precisaAlterarProduto;

          if (!formFiltroVazio)
            _precisaAlterarProduto =
              value !== estadoFormFiltro ? true : _precisaAlterarProduto;

          this.estadoAux = value;
          if (_precisaAlterarProduto)
            this.openModalProdutos(_precisaAlterarProduto);
          break;*/
        case 'fipeAtualizada':
          this.form.dadosVeiculo.veiculo.resultFipe = null;
          this.form.dadosVeiculo.veiculo.resultFipe =
            this.form.dadosVeiculo.fipeAtualizada;

          temResultFipeVazio = this._isObjectEmpty(value);
          preco = !temResultFipeVazio ? value.preco : 0;

          _precisaAlterarProduto = preco ? true : _precisaAlterarProduto;

          if (!formFiltroVazio) {
            const temFormFiltroValor = formFiltro.hasOwnProperty('valor')
              ? true
              : false;

            if (temFormFiltroValor && !temResultFipeVazio)
              _precisaAlterarProduto =
                preco !== formFiltro.valor ? true : _precisaAlterarProduto;
          }

          this.textoMsgNotificacao = 'FIPE Atualizada revise os produtos';
          this.corMessagemNoticacao = 'warning';

          if (_precisaAlterarProduto)
            this.openModalProdutos(_precisaAlterarProduto);
          break;
        case 'cilindradas':
          const temDiferencaCilindradas = value !== cilindradas;
          _precisaAlterarProduto = temDiferencaCilindradas
            ? true
            : _precisaAlterarProduto;

          if (!formFiltroVazio) {
            const temFormFiltroCilindradas = formFiltro.hasOwnProperty(
              'cilindradas',
            )
              ? true
              : false;

            if (temFormFiltroCilindradas)
              _precisaAlterarProduto =
                value !== formFiltro.cilindradas
                  ? true
                  : _precisaAlterarProduto;
          }

          if (_precisaAlterarProduto)
            this.openModalProdutos(_precisaAlterarProduto);
          break;
        case 'valorCobertura':
          _precisaAlterarProduto =
            valorCobertura !== value ? true : _precisaAlterarProduto;

          if (_precisaAlterarProduto)
            this.openModalProdutos(_precisaAlterarProduto);
          break;
        default:
          break;
      }
    },
    async buscaDados() {
      const objSend = {
        idProposta: this.$route.params.idCotacao,
        qtdPorPagina: this.itemsPerPage,
        idEmpresa: this.idEmpresa,
        urlOrigem: this.$route.fullPath,
      };
      if (!objSend.idProposta) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Você não tem acesso a visualização desta Proposta/Vistoria',
          color: 'danger',
        });
        return;
      }
      try {
        const { data: proposta } = await service.post(
          'Cotacao',
          'listarCotacoes',
          objSend,
        );

        if (proposta.length > 0) {
          this.dadosProposta = proposta[0];

          await Promise.all([
            this.buscaCoresECombustivel(),
            this.buscaFotosPorProposta(),
          ]);

          this.preencheProdutosSelecionadosFinanceiro();

          if (this.dadosProposta.tipoProposta === 'Adesão') {
            this.dadosProposta.tipoProposta = 'Contratação';
          }
        }
        await this.getHistorico(
          this.dadosProposta.idProposta,
          this.dadosProposta.idAssociado,
        );
      } catch (e) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: e,
          color: 'danger',
          time: 5000,
        });

        if (e == 'Usuário não tem permissão para acessar a proposta') {
          this.$router.push('/Cotacoes');
        }
      }
    },
    preencheProdutosSelecionadosFinanceiro() {
      this.form.dadosProduto.produtosSelecionados.forEach(async (produto) => {
        const produtoEncontrado = this.dadosProposta.produtos.find(
          (findProd) =>
            (produto.id_produto || produto.idProduto) === findProd.idProduto,
        );
        if (produtoEncontrado) {
          Object.assign(produto, {
            idTipoPagamentoEmpresa: produtoEncontrado.idTipoPagamentoEmpresa,
            nomePagamento: produtoEncontrado.nomePagamento,
          });
        }
      });
    },
    preencheProdutosSelecionadosFinanceiroOnSubmit() {
      this.form.dadosProduto.produtosSelecionados.forEach(async (produto) => {
        const produtoEncontrado = this.dadosProposta.produtos.find(
          (findProd) =>
            (produto.id_produto || produto.idProduto) === findProd.idProduto,
        );
        if (produtoEncontrado) {
          if (
            !produto.idTipoPagamentoEmpresa &&
            produtoEncontrado.idTipoPagamentoEmpresa
          ) {
            Object.assign(produto, {
              idTipoPagamentoEmpresa: produtoEncontrado.idTipoPagamentoEmpresa,
              nomePagamento: produtoEncontrado.nomePagamento,
            });
          }
        }
      });
    },
    async buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      const cachedRoutes = [
        'divisoes',
        'regionais',
        'gruposVeiculos',
        'usuarios',
      ];

      if (cachedRoutes.includes(model) && isValidCachedData(model)) {
        const cachedData = getFromCache(model);

        if (Object.values(cachedData.data).length) {
          this[array].push({ label: 'Selecione', id: null });

          cachedData.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        }
        return;
      }
      try {
        let dadosSelect = await service.getAll(
          'g',
          {},
          `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`,
        );
        dadosSelect.data = decryptData(dadosSelect.data);
        // saveToCache(model, dadosSelect);
        // estava buscando 4150 usuários, vou deixar aqui para um todo para melhorar esse cache

        const options = decryptData(dadosSelect.data);

        if (Object.values(options).length) {
          this[array].push({ label: 'Selecione', id: null });
          options.forEach((option) => {
            option.id = option[campoPK];
            option.label = option[campoDescricao];
            this[array].push(option);
          });
        }
      } catch {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível buscar opções',
          color: 'danger',
        });
      }
    },

    async buscaDadosSelects(model, array, campoDescricao, campoPK) {
      const cachedRoutes = ['domStatusCotacao'];

      if (cachedRoutes.includes(model) && isValidCachedData(model)) {
        const cachedData = getFromCache(model);

        if (Object.values(cachedData.data).length) {
          this[array].push({ label: 'Selecione', id: null });

          cachedData.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        }
        return;
      }

      try {
        let dadosSelect = await service.getAll('g', {}, `${model}/list/`);

        dadosSelect.data = decryptData(dadosSelect.data);

        if (Object.values(dadosSelect.data).length) {
          saveToCache(model, dadosSelect);
          dadosSelect.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });
        }
      } catch {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível buscar opções',
          color: 'danger',
        });
      }
    },

    async buscaFotosPorProposta() {
      const objSend = {
        idProposta: this.$route.params.idCotacao,
        idEmpresa: this.dadosProposta.idEmpresa,
        idGrupo: this.dadosProposta.idGrupo,
        idTipoFipe: this.dadosProposta.dadosVeiculo.codTipoVeiculo,
      };
      try {
        const { data: fotos } = await service.post(
          'Cotacao',
          'listarFotosCotacao',
          objSend,
        );
        fotos.forEach((foto) => {
          const fotosProposta = this.fotos.filter(
            (fotoFiltrada) => fotoFiltrada.id === foto.id_modeloFoto,
          );
          if (fotosProposta.length === 0)
            this.fotos.push({
              id: foto.id_modeloFoto,
              label: foto.nomePosicao,
            });
        });
        this.isMounted = true;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      }
    },
    coresCombustiveisMapper(data, dataKey) {
      return data[dataKey].map((item) => ({
        id: item.descricao,
        label: item.descricao,
      }));
    },
    async buscaCoresECombustivel() {
      const routeKey = 'listarCoresECombustivel';

      this.listaCores.push({ label: 'Selecione', id: null });
      this.listaCombustiveis.push({ label: 'Selecione', id: null });

      if (isValidCachedData(routeKey)) {
        const cachedData = getFromCache(routeKey);

        const cores = this.coresCombustiveisMapper(cachedData.data, 'cores');
        this.listaCores = [...this.listaCores, ...cores];

        const combustiveis = this.coresCombustiveisMapper(
          cachedData.data,
          'combustiveis',
        );

        this.listaCombustiveis = [...this.listaCombustiveis, ...combustiveis];

        return;
      }

      const result = await service.post('Cotacao', routeKey, {
        idRegional: this.dadosProposta.idRegional,
        idProposta: this.$route.params.idCotacao,
      });

      saveToCache(routeKey, result);

      const cores = this.coresCombustiveisMapper(result.data, 'cores');
      this.listaCores = [...this.listaCores, ...cores];

      const combustiveis = this.coresCombustiveisMapper(
        result.data,
        'combustiveis',
      );
      this.listaCombustiveis = [...this.listaCombustiveis, ...combustiveis];
    },
    async buscaColaboradoresDoCadastro() {
      const idSetorCadastro = await this.buscarIdDoSetorCadastro();

      const routeKey = 'colaboradoresCadastro';

      if (isValidCachedData(routeKey)) {
        const cachedData = getFromCache(routeKey);

        this.colaboradoresCadastro = cachedData.data.map((colaborador) => {
          return {
            id: colaborador.idUsuario,
            label: colaborador.nome,
          };
        });

        this.colaboradoresCadastro.unshift({ label: 'Selecione', id: null });

        return;
      }

      service
        .post('Usuario', 'buscarUsuario', {
          idEmpresa: this.idEmpresa,
          idSetor: idSetorCadastro.id,
        })
        .then((res) => {
          this.colaboradoresCadastro = res.data.map((colaborador) => {
            return {
              id: colaborador.idUsuario,
              label: colaborador.nome,
            };
          });
          this.colaboradoresCadastro.unshift({ label: 'Selecione', id: null });
          saveToCache(routeKey, res);
        })
        .catch(() => {});
    },
    buscarIdDoSetorCadastro() {
      const cacheKey = 'idSetorCadastro';

      if (isValidCachedData(cacheKey)) {
        return getFromCache(cacheKey);
      }

      return new Promise((resolve, reject) => {
        service
          .post('Setor', 'buscar-id-setor-por-nome', {
            idEmpresa: this.idEmpresa,
            nomeSetor: 'cadastro',
          })
          .then((res) => {
            saveToCache(cacheKey, res.data);
            resolve(res.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    openModalProdutos(_precisaAlterarProduto = false) {
      this.modalProdutos = true;
      this.mostrarRangeComissao();
      this.precisaAlterarProduto = _precisaAlterarProduto;
    },
    mostrarRangeComissao() {
      const isAllowEditComission = this.$can(
        `Alterar valores de comissão regional`,
        'Cotações',
      );
      const isValidMinValue = this.regional.valorMinimoComissao !== null;
      const isValidMaxValue = this.regional.valorMaximoComissao > 0;

      this.configurarComissao =
        isAllowEditComission && isValidMinValue && isValidMaxValue;
    },
    _isObjectEmpty(value) {
      const isEmpty =
        value && Object.keys(value).length && value.constructor === Object;

      return !isEmpty;
    },
    _isObject(value) {
      const isObject =
        typeof value === 'object' && !Array.isArray(value) && value !== null;

      return isObject;
    },
    async carregarFull() {
      this.$vs.loading();
      const buscaTodosDadosSelect = [
        this.buscaColaboradoresDoCadastro(),
        this.buscaDadosSelects(
          'domStatusCotacao',
          'status',
          'nomeStatus',
          'idStatus',
        ),
        this.buscaDadosSelectsPorEmpresa(
          'regionais',
          'regionais',
          'nome',
          'idRegional',
        ),
        this.buscaDadosSelectsPorEmpresa(
          'divisoes',
          'divisoes',
          'nomeDivisao',
          'idDivisao',
        ),
        this.buscaDadosSelectsPorEmpresa(
          'usuarios',
          'consultores',
          'nome',
          'idUsuario',
        ),
        this.buscaDadosSelectsPorEmpresa(
          'gruposVeiculos',
          'grupos',
          'nomeGrupo',
          'idGrupo',
        ),
      ];
      await this.buscaDados();

      await Promise.all(buscaTodosDadosSelect);
      await this.buscaDadosUsuario(),
        (this.cidadeAux =
          this.form.dadosCliente.cidade ||
          this.dadosProposta.dadosCliente.cidade);
      this.estadoAux =
        this.form.dadosCliente.estado || this.dadosProposta.dadosCliente.estado;

      const regional = this.regionais.find(
        ({ id }) => id === this.form.dadosGerais.idRegional,
      );
      this.regional = regional;
      this.carregadoFull = true;
      this.$vs.loading.close();
    },
    decoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        this.idUsuario = this.decoded.id_usuario;
        this.idEmpresa = this.decoded.id_empresa;
      }
    },
    ajustaKm() {
      const _km = Number(this.form.dadosVeiculo.km);
      this.form.dadosVeiculo.km = !_km ? 1 : Number(this.form.dadosVeiculo.km);
    },
    async getHistorico(idProposta, idAssociado) {
      const respostaLogs = await service.post('Cotacao', 'buscaLogsProposta', {
        idProposta,
        idAssociado,
      });
      const logsAlteracoes = respostaLogs.data;

      const logComIdStatus = logsAlteracoes.find(
        (log) => log.campo === 'idStatus',
      );

      const statusFoiRevertido =
        logComIdStatus &&
        logComIdStatus.novo_dadoOld === '4 - Finalizada' &&
        logComIdStatus.novo_dadoNew === '3 - Aguardando Aprovação';

      if (statusFoiRevertido) {
        this.verificaStatusAlterarPlacaChassi = true;
      }
    },

    async openModalLogs(obj) {
      this.$vs.loading();
      this.modalLogs = true;
      if (obj.idProposta)
        service
          .post('Cotacao', 'buscaLogsProposta', {
            idProposta: obj.idProposta,
            idAssociado: obj.dadosCliente.idProspect,
          })
          .then((res) => {
            res.data.map((item) => {
              if (parseInt(item.dadoOld) === parseInt(item.dadoNew)) return;
              if (
                item.dadoOld &&
                !isNaN(item.dadoOld) &&
                item.dadoOld.includes('.')
              ) {
                item.dadoOld = Number(item.dadoOld).toFixed(2);
              }
              if (
                item.dadoNew &&
                !isNaN(item.dadoNew) &&
                item.dadoNew.includes('.')
              ) {
                item.dadoNew = Number(item.dadoNew).toFixed(2);
              }
              if (
                item.campo.split('- ')[1] == 'descontoConcedido' ||
                item.campo == 'valorCotaParticipacao'
              ) {
                item.dadoOld = `${item.dadoOld} %`;
                item.dadoNew = `${item.dadoNew} %`;
              }
              if (
                ['valorFinal', 'valor'].includes(item.campo.split('- ')[1]) ||
                [
                  'valorCobertura',
                  'valorParticipacaoMinimo',
                  'valorFipe',
                ].includes(item.campo)
              ) {
                item.dadoOld = `R$ ${item.dadoOld}`;
                item.dadoNew = `R$ ${item.dadoNew}`;
              }
              if (
                ['dataNascimento', 'dataVencimentoCnh'].includes(item.campo)
              ) {
                item.dadoOld = moment(item.dadoOld).utc().format('DD/MM/YYYY');
                item.dadoNew = moment(item.dadoNew).utc().format('DD/MM/YYYY');
              }
              if (
                [
                  'idUsuario',
                  'idUsuarioResponsavelVistoria',
                  'idStatus',
                ].includes(item.campo)
              ) {
                item.dadoNew = item.novo_dadoNew;
                item.dadoOld = item.novo_dadoOld;
              }
              if (item.tabela == 'PropostasComplementos') {
                item.tabela = item.novo_dadoNew;
              }
              item.createdAt = moment(item.createdAt)
                .utc()
                .format('DD/MM/YYYY - HH:mm');
              this.logsAlteracoes.push(item);
            });
            this.$vs.loading.close();
          });
    },
    async liberarAguardandoAprovacao() {
      this.$vs.loading();

      const objSend = {
        idStatus: this.dadosProposta.idStatus,
        idProposta: this.dadosProposta.idProposta,
      };

      try {
        await service.post('Cotacao', 'liberar-aguardando-aprovacao', objSend);
        await this.carregarFull();
      } catch (e) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: e,
          color: 'danger',
        });
      }
    },
    resetModalLogs() {
      this.logsAlteracoes = [];
    },
    async buscaDadosUsuario() {
      try {
        const { data } = await obterDadosUsuarioLogado(
          this.idEmpresa,
          this.idUsuario,
        );
        const [dadosUsuario] = data;

        const superUser = verificaUsuarioAdmin();
        this.dadosUsuario = { ...dadosUsuario, superUser };
        // await this.translate(this.idEmpresa);
      } catch (error) {
        this.$vs.loading.close();
      }
    },
    getStatusColor(data) {
      return functions.getStatusColor(data);
    },
    verificaEmpresaBemProtege(idEmpresa) {
      return functions.verificaEmpresaBemProtege(idEmpresa);
    },
    async buscaDadosEmpresa() {
      const res = await service.getAll(
        'g',
        {},
        'empresas/list/idEmpresa/' + this.idEmpresa + '/cache',
      );

      res.data = decryptData(res.data);
      const [data] = res.data;
      // const { ativaMascarasVeiculos } = data;
      // this.ativaMascarasVeiculos = ativaMascarasVeiculos || true;
      const { permiteVariasCotacoesPorPlaca } = data;

      this.permiteVariasCotacoesPorPlaca = permiteVariasCotacoesPorPlaca;
      this.dadosEmpresa = data;
      this.dadosEmpresaLoaded = true;
    },
    validaSituacaoPlacaChassi(codigoSituacaoPlaca) {
      const cotacaoLiberada =
        [
          SITUACAO_PLACA.PERMITIR_COM_RESTRICAO,
          SITUACAO_PLACA.PERMITIR,
        ].includes(codigoSituacaoPlaca) ||
        (SITUACAO_PLACA.NAO_PERMITIR === codigoSituacaoPlaca &&
          this.$can(`Permitir cotação com pendência financeira`, 'Cotações'));
      this.habilitaDesabilitaBtnSalvar = !cotacaoLiberada;
      return;
    },
    recarregaPagina() {
      window.location.reload(true);
    },
    naoSalvarProdutos(nenhumProdutoEncontrado) {
      if (nenhumProdutoEncontrado) {
        this.habilitaDesabilitaBtnSalvar = true;
      } else {
        this.habilitaDesabilitaBtnSalvar = false;
      }
    },
    atualizarParticipacao(dados) {
      const {
        value: { valorCotaParticipacao, valorParticipacaoMinimo },
      } = dados;

      this.form.dadosVeiculo.valorParticipacaoMinimo = valorParticipacaoMinimo;
      this.form.dadosVeiculo.valorCotaParticipacao = valorCotaParticipacao;

      this.$forceUpdate();
    },
    async voltarStatusProposta(alterarStatus) {
      const idProposta = this.dadosProposta.idProposta;
      const idStatus = alterarStatus
        ? STATUS_COTACAO.AGUARDANDO_APROVACAO
        : STATUS_COTACAO.FINALIZADA;

      try {
        await service.post('Cotacao', 'voltarStatusProposta', {
          idProposta,
          idStatus,
        });

        this.notificar(
          'Status da proposta alterado com sucesso',
          'success',
          3500,
        );

        setTimeout(() => this.recarregaPagina(), 2000);
      } catch (error) {
        this.notificar(error, 'warning', 3500);
      }
    },
    validarCamposFormulario(errosValidacao) {
      errosValidacao.forEach((campoInvalido) => {
        const campoValidar = this.camposValidacaoObrigatorios.includes(
          campoInvalido.field,
        );

        if (campoValidar) {
          this.formEdicaoInvalido = true;

          this.notificar(campoInvalido.msg, 'danger', 5000);
        }
      });
    },
    changeProposalType() {
      this.$refs.changePorposalTypeMethod.changePorposalTypeMethod();
    },
  },
  async created() {
    this.decoded();
    await this.buscaDadosEmpresa();
  },
  async mounted() {
    await this.translate(this.idEmpresa);
    // this.$validator.localize('ptBr', locale);
    localStorage.removeItem('formFiltro');

    await this.carregarFull();
  },
};
</script>

<style>
.vs-chip-bg-pink {
  background-color: rgb(255, 68, 0);
}

.vs-chip-bg-blue {
  background-color: navy;
}
.vdp-datepicker input {
  width: 100%;
}
#meu-popup-personalizado.con-vs-popup .vs-popup {
  width: 60%;
}

@media (max-width: 870px) {
  #meu-popup-personalizado.con-vs-popup .vs-popup {
    min-width: 95%;
  }
}
</style>
<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
